export const DEFAULT_FIRST_ITEM = 1;
export const DEFAULT_LAST_ITEM = 20;
